import { useState, useEffect, useRef, createRef } from "react";
import styles from "./styles.module.css";
import { useMethods } from "../../utils/methods";
import useSelectedParams from "../../utils/useselectedparams";
import ReactDOM from "react-dom";
import { makeid } from "../../utils/pageactions";
import Params from "./params";
import sources from "../../utils/sources";
import usePropFormatter from "../../utils/usepropformatter";
import { Utilities, Values, Options, Fields, Basic } from "./dropdownsections";
const Dropdown = ({
  position,
  onClose,
  value,
  type,
  list,
  onChange,
  onDelete,
  extraSources,
}) => {
  const [paramEdit, setParamEdit] = useState(null);
  const scrollContainer = useRef();
  const handleClose = () => {
    onClose();
  };

  const paramSubmit = (method, index) => {
    const _v = { ...value };
    _v[index + 1] = method;
    console.log(_v);
    onChange(_v);
    if (method.returnType === type && method.returnList === list) {
      handleClose();
    } else {
      scrollContainer.current.scrollBy({ left: 300, behavior: "smooth" });
    }
    setParamEdit(null);
  };

  useEffect(() => {
    if (position) {
      scrollContainer.current.scrollTo(scrollContainer.current.scrollWidth, 0);
    }
  }, [position]);

  const onSelect = (d, index) => {
    if (!d.params || d.params.length > 0) {
      return setParamEdit({ ...d, index: index });
    }
    const _v = { ...value };
    _v[index + 1] = {
      value: d.code,
      name: d.name,
      field: d.field || null,
      ofType: d.ofType || null,
      returnType: d.returnType,
      returnList: d.returnList,
      props: {},
      params: [],
      id: makeid(16),
      async: d.async ? d.async : null,
      fields: d.fields || [],
    };
    Object.keys(_v).forEach((key) => {
      if (key > index + 1) {
        delete _v[key];
      }
    });
    onChange(_v);
    if (d.returnType === type && d.returnList === list) {
      handleClose();
    } else {
      scrollContainer.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };
  if (!position) {
    return null;
  }
  return ReactDOM.createPortal(
    <>
      <div
        style={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          top: 0,
          zIndex: 4000,
          boxSizing: "border-box",
        }}
        onClick={handleClose}
      >
        <div
          style={{
            right: position.x,
            top: position.y,
            height: position.height,
          }}
          className={styles.dropdown}
          onClick={(e) => e.stopPropagation()}
        >
          <BreadCrum value={value} />
          <div
            ref={scrollContainer}
            style={{ height: position.height - 88 }}
            className={styles.dropdownContainer}
          >
            <DropdownSection
              value={{}}
              index={-1}
              selected={value[0]}
              onSelect={onSelect}
              extraSources={extraSources}
            />
            {Object.values(value).map((v, index) => {
              return (
                <DropdownSection
                  value={v}
                  index={index}
                  selected={value[index + 1]}
                  onSelect={onSelect}
                  props={v.props}
                  key={index}
                  extraSources={[]}
                />
              );
            })}
          </div>

          <div className={styles.deleteContainer}>
            <button onClick={onDelete} className={styles.delete}>
              Delete
            </button>
          </div>
        </div>
      </div>

      <Params
        open={paramEdit}
        onClose={() => setParamEdit(null)}
        sources={sources}
        onSubmit={paramSubmit}
      />
    </>,
    document.getElementById("modals")
  );
};

export default Dropdown;

const DropdownSection = ({
  value,
  props = {},
  selected = {},
  onSelect,
  index,
  extraSources,
}) => {
  const { options, categories } = useMethods(
    value.returnType,
    value.returnList,
    extraSources,
    value.fields
  );

  return (
    <div className={styles.dropdownSection}>
      <div
        style={{
          overflowY: "auto",
          borderLeft: "1px solid var(--main-border-color)",
          flexGrow: 1,
          flexBasis: 0,
        }}
      >
        {Object.keys(props).length > 0 && (
          <PropViewer props={props} params={value.params} />
        )}
        {categories.map((cat) => {
          if (cat === "Utilities") {
            return (
              <Utilities
                key={cat}
                options={options.filter((x) => x.category === "Utilities")}
                onSelect={(v) => onSelect(v, index)}
                selected={selected}
              />
            );
          }
          if (cat === "Values") {
            return (
              <Values
                key={cat}
                options={options.filter((x) => x.category === "Values")}
                onSelect={(v) => onSelect(v, index)}
                selected={selected}
              />
            );
          }
          if (cat === "Options") {
            return (
              <Options
                key={cat}
                options={options.filter((x) => x.category === "Options")}
                onSelect={(v) => onSelect(v, index)}
                selected={selected}
              />
            );
          }
          if (cat === "Fields") {
            return (
              <Fields
                key={cat}
                options={options.filter((x) => x.category === "Fields")}
                onSelect={(v) => onSelect(v, index)}
                selected={selected}
              />
            );
          }

          return (
            <Basic
              key={cat}
              options={options.filter((x) => x.category === cat)}
              category={cat}
              onSelect={(v) => onSelect(v, index)}
              selected={selected}
            />
          );
        })}
      </div>
    </div>
  );
};

const PropViewer = ({ props, params }) => {
  const { _props } = usePropFormatter({ props });
  if (!_props) {
    return null;
  }
  return (
    <div
      style={{
        padding: 10,
        borderBottom: "1px solid var(--main-border-color)",
        position: "relative",
      }}
    >
      {params.map((p) => {
        return (
          <div style={{ marginBottom: 12 }} key={p.name}>
            <div className={styles.paramInputTitle}>{p.displayName}</div>
            {typeof _props[p.name] !== "object" && (
              <div className={styles.paramValue}>{_props[p.name]}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

const BreadCrum = ({ value }) => {
  const [_value, setValue] = useState("");

  useEffect(() => {
    const __ = [];
    const length = Object.keys(value).length;
    Object.values(value).forEach((x, i) => {
      if (i === 0) {
        return __.push(x.name);
      }
      if (i === 1 && i <= length - 3) {
        return __.push("...");
      }
      if (i > length - 3) {
        return __.push(x.name);
      }
    });

    setValue(__.join(" > "));
  }, [value]);
  return <div className={styles.sectionTitle}>{_value}</div>;
};
